import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { User } from "./types";

interface UserState {
  userInfoData: User | null;
  isAuthenticated: boolean;
  setUserInfoData: (data: User | null) => void;
  updateUserInfo: (data: Partial<User>) => void;
  clearUser: () => void;
}

const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      userInfoData: null,
      isAuthenticated: false,

      setUserInfoData: (data) =>
        set({
          userInfoData: data,
          isAuthenticated: !!data,
        }),

      updateUserInfo: (data) =>
        set((state) => ({
          userInfoData: state.userInfoData ? { ...state.userInfoData, ...data } : null,
        })),

      clearUser: () =>
        set({
          userInfoData: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: "user-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useUserStore;
